import { z } from "zod";
import {
  CollectNodeFieldTypeEnum,
  DateFieldTypeEnum,
} from "../../../../enum/nodes.enum";
import { isValid, parseISO } from "date-fns";

export const collectNodeDateFieldSchema = z.object({
  type: z.literal(CollectNodeFieldTypeEnum.DATE),
  dateRange: z
    .object({
      type: z
        .nativeEnum(DateFieldTypeEnum, {
          errorMap: () => ({ message: "Invalid date range type" }),
        })
        .optional(),
      startDate: z
        .string()
        .optional()
        .refine((v) => {
          if (!v) return true;
          // if v is not valid date throw error
          return isValid(parseISO(v));
        }),
      endDate: z
        .string()
        .optional()
        .refine((v) => {
          if (!v) return true;
          return isValid(parseISO(v));
        }),
    })
    .optional(),
  weekDays: z.array(z.string()).default([]).optional(),
});
